import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb, CheckCircle2 } from 'lucide-react';
export function SolutionSection() {
  const solutions = ['Un protocolo claro', 'Una evaluación estructurada', 'Un sistema de seguimiento definido', 'Datos concretos desde el primer día'];
  return <section className="py-20 px-4 bg-slate-950 relative overflow-hidden" data-id="element-157">
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-teal-900/20 blur-[100px] rounded-full pointer-events-none" data-id="element-158"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-160">
          <div className="inline-flex items-center justify-center p-4 bg-teal-950 rounded-full mb-6 border border-teal-800" data-id="element-161">
            <Lightbulb className="w-10 h-10 text-teal-400" data-id="element-162" />
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6" data-id="element-163">
            Imaginá esto
          </h2>
          <p className="text-2xl text-slate-300" data-id="element-164">
            Cada paciente entra a tu consulta…
          </p>
          <p className="text-xl text-slate-400 mt-2" data-id="element-165">Y vos ya tenés:</p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12" data-id="element-166">
          {solutions.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-slate-900 border border-teal-900/50 p-6 rounded-xl flex items-start gap-4 shadow-lg shadow-teal-900/10" data-id="element-167">
              <CheckCircle2 className="w-6 h-6 text-teal-400 flex-shrink-0 mt-1" data-id="element-168" />
              <span className="text-lg font-semibold text-white" data-id="element-169">{item}</span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-gradient-to-r from-teal-950 to-slate-900 p-8 rounded-2xl border border-teal-800/50" data-id="element-170">
          <p className="text-2xl font-bold text-amber-400 mb-4" data-id="element-171">
            👉 Todo organizado. Todo medible. Todo profesional.
          </p>
          <p className="text-xl text-white font-medium" data-id="element-172">
            Y eso cambia absolutamente todo.
          </p>
        </motion.div>
      </div>
    </section>;
}